import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import map from 'lodash/map';
import find from 'lodash/find';
import values from 'lodash/values';
import groupBy from 'lodash/groupBy';

import BarChart from 'components/BarChart';
import { FREQUENCY, RELATIVE_FREQUENCY } from 'scenes/GraphicalStatistics/SettingsForm/AdditionalFields/Component';

import { getFilteredDataset, getFrequencyDataSet, getCategoricalSummary } from 'store/dataset';

import { getRelativeFrequencySammaryByFrequencySummary } from 'calculators/graphicalStatistics/frequencyTable';
import { removeEmptyValuesFromDataset } from 'utilities';

const BarChartContainer = props => {
  const {
    summary,
    firstParameterName,
    isFrequencyTable,
    isTypeOfGraphsFrequency,
    filteredDataset,
    secondParameterName,
    frequencyDataSet,
    typeOfFrequencyDataSet
  } = props;

  const levelsSummary = () => {
    const frequencySummary = values(summary[firstParameterName].levels);

    if (isTypeOfGraphsFrequency) {
      return frequencySummary;
    }
    return getRelativeFrequencySammaryByFrequencySummary(frequencySummary);
  };

  const stackedBarChartData = () => {
    const filteredDatasetWithoutEmpty = removeEmptyValuesFromDataset(filteredDataset, firstParameterName, secondParameterName);

    const datasetGroupedByFirstParameter = groupBy(
      filteredDatasetWithoutEmpty,
      firstParameterName
    );

    const frequencyData = map(
      datasetGroupedByFirstParameter,
      (datasetChunk, firstParameterValue) => {
        const datasetChunkGroupedBySecondParameter = groupBy(
          datasetChunk, secondParameterName
        );

        const levels = map(
          datasetChunkGroupedBySecondParameter,
          (datasetChunkGrouped, secondParameterValue) => ({
            name: secondParameterValue,
            count: datasetChunkGrouped.length
          })
        );

        return { name: firstParameterValue, count: datasetChunk.length, levels };
      }
    );

    if (isTypeOfGraphsFrequency) {
      return frequencyData;
    }
    return getRelativeFrequencySammaryByFrequencySummary(frequencyData);
  };

  const frequencyStackedBarChartData = () => {
    const frequencyData = find(frequencyDataSet, firstParameterName)[firstParameterName].levels;
    if (isTypeOfGraphsFrequency) {
      return frequencyData;
    }
    return getRelativeFrequencySammaryByFrequencySummary(frequencyData);
  };

  const stackedData = () => {
    if (isFrequencyTable) {
      return frequencyStackedBarChartData();
    }
    return stackedBarChartData();
  };

  const yAxisLabel = () => {
    if (typeOfFrequencyDataSet === RELATIVE_FREQUENCY) {
      return RELATIVE_FREQUENCY;
    }
    if (isTypeOfGraphsFrequency) {
      return FREQUENCY;
    }
    return RELATIVE_FREQUENCY;
  };

  return (
    <BarChart
      stacked={!!secondParameterName}
      bars={secondParameterName ? stackedData() : levelsSummary()}
      xAxisLabel={firstParameterName}
      yAxisLabel={yAxisLabel()}
    />
  );
};

BarChartContainer.propTypes = {
  summary: PropTypes.object.isRequired,

  filteredDataset: PropTypes.array.isRequired,

  frequencyDataSet: PropTypes.array,
  isFrequencyTable: PropTypes.bool.isRequired,

  firstParameterName: PropTypes.string.isRequired,
  secondParameterName: PropTypes.string.isRequired,

  isTypeOfGraphsFrequency: PropTypes.bool.isRequired,
  typeOfFrequencyDataSet: PropTypes.string
};

const mapStateToProps = state => ({
  summary: getCategoricalSummary(state),
  filteredDataset: getFilteredDataset()(state),
  frequencyDataSet: getFrequencyDataSet(state)
});

export default connect(mapStateToProps)(BarChartContainer);
